import React from 'react';
import { Lightning } from '@phosphor-icons/react';
import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

export const estadoConfig = {
  agendado: { label: 'Agendado', color: '#6C757D', bgColor: '#6C757D20' },
  en_espera_asignacion: { label: 'En Espera de Asignación', color: '#0891B2', bgColor: '#0891B220' },
  asignado: { label: 'Asignado', color: '#008630', bgColor: '#00863020' },
  realizada: { label: 'Realizada', color: '#065F46', bgColor: '#065F4620' },
  suspendida: { label: 'Suspendida', color: '#78716C', bgColor: '#78716C20' },
  aprobado: { label: 'Aprobado', color: '#C1121F', bgColor: '#C1121F20' },
  rechazado: { label: 'Rechazado', color: '#FF3B30', bgColor: '#FF3B3020' },
};

const formatShort = (iso) => {
  if (!iso) return '';
  try {
    return format(parseISO(iso), "d MMM yyyy, HH:mm", { locale: es });
  } catch {
    return '';
  }
};

const AuditLine = ({ label, actor, at, color }) => {
  if (!actor) return null;
  return (
    <p
      data-testid={`audit-${label.toLowerCase()}`}
      className="text-xs font-['IBM_Plex_Sans'] mt-1"
      style={{ color }}
    >
      <strong>{label} por:</strong> {actor}
      {at && <span className="text-[#6C757D]"> · {formatShort(at)}</span>}
    </p>
  );
};

export const MovilizacionStatusHeader = ({ movilizacion }) => {
  const estado = estadoConfig[movilizacion.estado] || estadoConfig.agendado;
  return (
    <div className="flex-1">
      <div className="flex items-center gap-3 mb-2 flex-wrap">
        <span
          className="px-3 py-1 text-sm font-bold font-['IBM_Plex_Sans']"
          style={{ backgroundColor: estado.bgColor, color: estado.color }}
        >
          {estado.label}
        </span>
        {movilizacion.es_emergente && (
          <span
            data-testid="emergente-tag"
            className="flex items-center gap-1 px-2 py-1 text-xs font-bold bg-[#C1121F] text-white font-['IBM_Plex_Sans']"
          >
            <Lightning size={12} weight="fill" /> EMERGENTE
          </span>
        )}
        <span className="text-xs text-[#6C757D] font-['IBM_Plex_Sans']">
          ID: {movilizacion.id ? movilizacion.id.slice(0, 8) : 'N/A'}
        </span>
      </div>
      <p className="text-xs text-[#495057] font-['IBM_Plex_Sans']">
        Solicitado por: {movilizacion.usuario_email}
      </p>
      {movilizacion.created_at && (
        <p
          data-testid="ficha-created-at"
          className="text-xs text-[#6C757D] font-['IBM_Plex_Sans'] mt-1"
        >
          <strong>Ficha generada:</strong> {formatShort(movilizacion.created_at)}
        </p>
      )}
      <AuditLine label="Aprobado" actor={movilizacion.aprobado_por} at={movilizacion.aprobado_at} color="#0891B2" />
      <AuditLine label="Asignado" actor={movilizacion.asignado_por} at={movilizacion.asignado_at} color="#008630" />
      <AuditLine label="Rechazado" actor={movilizacion.rechazado_por} at={movilizacion.rechazado_at} color="#FF3B30" />
    </div>
  );
};
